import classnames from 'classnames';
import React from 'react';

const Footer = () => {
  return (
    <footer
      className={classnames(
        'fixed-bottom',
        'bg-primary-dark2',
        'mt-auto',
        'd-none',
        'd-lg-flex',
        'justify-content-between',
        'align-items-center',
        'py-3',
        'px-5',
        'fixed-bottom'
      )}
    >
      <div className="container-xl">
        <p className="m-0 text-white">
          ©Nomad 2020-{new Date().getFullYear()}
        </p>
        {/* TODO add this when we have the link to Privacy Policy */}
        {/* <NavLink className="text-white" to="/">
          Privacy Policy
        </NavLink> */}
      </div>
    </footer>
  );
};

export default Footer;
